<template>
  <div>
    <table v-if="!empty" class="table-default">
      <thead style="background-color: #0000000a">
        <tr>
          <th />
          <th>Name</th>
          <th />
          <th>Date</th>
          <th />
        </tr>
      </thead>
      <tbody class="tbody__td--nowrap">
        <tr v-for="i in runs" :key="i.id" class="row--clickable" @click="open(i)">
          <td class="td--shrink pr-4">
            <IconCalibrationSequence
              v-if="i.sample.sequence && i.sample.sequence.is_calibration_mode"
              style="margin-left: 3px"
            />
            <IconSequence v-else-if="i.sample.sequence" style="margin-left: 3px" />
            <IconStandard v-else-if="i.sample.type === 'standard'" style="margin-left: 3px" />
            <IconSample v-else style="margin-left: 3px" />
          </td>
          <td class="td--overflow-hidden">
            <InjectionLinkComponent :injection="i" :first-icon="false" class="text-bold-blue" />
          </td>
          <td>
            <StatesForEntity
              :hasTitleOnAdaptive="false"
              :state="i.state"
              data-test-id="state-run"
            />
          </td>
          <td class="td--shrink text-gray" v-html="formatDate(new Date(i.created))" />
          <td class="td--shrink text-gray" v-html="formatTime(i.created)" />
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
  import _ from 'lodash';

  import StatesForEntity from '@/uikitProject/states/packs/StatesForEntity.vue';
  import InjectionLinkComponent from 'components/element/InjectionLinkComponent.vue';
  import IconSequence from '@/uikitProject/icons/IconSequence.vue';
  import IconSample from '@/uikitProject/icons/IconSample.vue';
  import IconStandard from '@/uikitProject/icons/IconStandard';
  import IconCalibrationSequence from '@/uikitProject/icons/IconCalibrationSequence.vue';

  export default {
    name: 'RunsListComponent',

    components: {
      IconCalibrationSequence,
      IconSample,
      IconSequence,
      IconStandard,
      InjectionLinkComponent,
      StatesForEntity,
    },

    props: {
      runs: Array,
    },

    computed: {
      empty() {
        return _.isEmpty(this.runs);
      },
    },

    methods: {
      open(r) {
        if (r.sample.sequence) {
          this.$router.push({
            name: 'sequence child injection',
            params: { id: r.sample.sequence.id, sid: r.sample.id, iid: r.id },
          });
        } else if (r.sample.type === 'sample') {
          this.$router.push({
            name: 'sample injection',
            params: { id: r.sample.id, iid: r.id },
          });
        } else if (r.sample.type === 'standard') {
          this.$router.push({
            name: 'standard injection',
            params: { id: r.sample.id, iid: r.id },
          });
        }
      },
    },
  };
</script>
